const Loader = () => {
  return (<p>Loader</p>)
}

export default Loader;